import React from 'react';
import OurSingleExpertise from '../OurSingleExpertise/OurSingleExpertise';

const OurExpertise = ({ title, subtitle, content, OurExpertiseData }) => {
   return (
      <>
         <section className="features__area pt-115 pb-90">
            <div className="tw-container tw-mx-auto">
               <div className="tw-flex tw-flex-wrap tw--mx-3">
                  <div className="tw-w-full tw-px-3">
                     <div className="features__content-center mb-5 width-50 tw-mx-auto">
                        <div className="section__title section__title-h2 tw-text-center mb-25">
                           <span>{title}</span>
                           <h2>{subtitle}</h2>
                        </div>
                        <p>{content}</p>
                     </div>
                  </div>
               </div>
               {OurExpertiseData && (
                  <div className="tw-flex tw-flex-wrap tw--mx-3">
                     <div className="tw-w-full tw-px-3">
                        <div className="features__content-right">
                           <div className="tw-flex tw-flex-wrap tw--mx-3">
                              {OurExpertiseData.map((item, index) => {
                                 return <div key={index} className="tw-w-full tw-px-3 md:tw-w-1/2">
                                    <OurSingleExpertise icon={item.icon} title={item.title} content={item.content} />
                                 </div>
                              })}
                           </div>
                        </div>
                     </div>
                  </div>
               )}
            </div>
         </section>
      </>
   );
};

export default OurExpertise;